<template>
  <article class="info-section elr-container-full">
    <div class="elr-row">
      <div class="elr-col-full">
        <div class="info-section-header">
          <pre>{{item}}</pre>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import axios from 'axios';

export default {
  name: 'WishlistItem',
  props: {
    user: {
      type: Object,
      required: true
    },
    authenticated: {
      type: Boolean
    },
    ponyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      item: {}
    };
  },
  mounted() {
    this.fetchItem(this.ponyId);
  },
  methods: {
    fetchItem(ponyId) {
      axios
        .get(`${process.env.VUE_APP_ROOT_API}/wishlist-item/${ponyId}`)
        .then(({ data }) => {
          this.item = data.item;
        })
        .catch(e => {
          if (e && e.response) {
            return e.response.data;
          }
        });
    }
  }
};
</script>
